// pdp-featured-collection-filter.js
(() => {
  // Only run on storefront product pages (inside the theme editor preview iframe this is still /products/...)
  if (!/\/products\//.test(window.location.pathname)) return;

  const HIDE_CLASS = "is-hidden-by-variant"; // base.css already has display:none !important

  // Current product handle
  const parts = window.location.pathname.split("/products/");
  const currentHandle = (parts[1] || "").split(/[/?#]/)[0];
  if (!currentHandle) return;

  // ---------------------------------
  // Utils
  // ---------------------------------
  const norm = (s) =>
    String(s || "")
      .toLowerCase()
      .replace(/\s+/g, " ") // collapse whitespace + newlines
      .trim();

  function getProductTags() {
    // 1) ShopifyAnalytics meta (common)
    try {
      const t = window?.ShopifyAnalytics?.meta?.product?.tags;
      if (Array.isArray(t)) return t;
      if (typeof t === "string" && t.length) return t.split(",").map((x) => x.trim());
    } catch (e) {}

    // 2) window.meta product (some themes)
    try {
      const t = window?.meta?.product?.tags;
      if (Array.isArray(t)) return t;
      if (typeof t === "string" && t.length) return t.split(",").map((x) => x.trim());
    } catch (e) {}

    // 3) Dawn-like ProductJson scripts
    try {
      const scripts = document.querySelectorAll(
        'script[type="application/json"][id^="ProductJson-"], script[type="application/json"]#ProductJSON, script[type="application/json"]#product-json'
      );
      for (const sc of scripts) {
        const obj = JSON.parse(sc.textContent || "null");
        if (obj && Array.isArray(obj.tags)) return obj.tags;
      }
    } catch (e) {}

    return [];
  }

  function getCurrentSleeveType() {
    const tags = getProductTags().map(norm);

    // Your tag format:
    // sleeve:shortsleeve, sleeve:longsleeve, sleeve:sleeveless
    if (tags.includes("sleeve:longsleeve")) return "longsleeve";
    if (tags.includes("sleeve:shortsleeve")) return "shortsleeve";
    if (tags.includes("sleeve:sleeveless")) return "sleeveless";

    // Fallback: detect from URL keywords
    const url = norm(window.location.pathname);
    if (url.includes("long-sleeve") || url.includes("longsleeve")) return "longsleeve";
    if (url.includes("short-sleeve") || url.includes("shortsleeve")) return "shortsleeve";
    if (url.includes("sleeveless") || url.includes("tank")) return "sleeveless";

    return null;
  }

  function removeCurrentProductCards(scope) {
    const links = scope.querySelectorAll('a[href*="/products/"]');
    links.forEach((a) => {
      const href = a.getAttribute("href") || "";
      const clean = href.split(/[?#]/)[0];

      if (clean.includes(`/products/${currentHandle}`)) {
        const card =
          a.closest("li") ||
          a.closest(".grid__item") ||
          a.closest(".collection-product-card") ||
          a.closest(".swiper-slide") ||
          a.closest(".card") ||
          a;

        card?.remove?.();
      }
    });
  }

  function recalcSliders() {
    document.querySelectorAll("slider-component, slideshow-component").forEach((c) => {
      try {
        c.resetPages?.();
      } catch (e) {}
      try {
        c.update?.();
      } catch (e) {}
    });
    window.dispatchEvent(new Event("resize"));
  }

  // Find the Shopify section whose *textContent* contains any of the needles (supports EN/ES)
  function findSectionContainingAnyText(needles) {
    const list = (needles || []).map(norm).filter(Boolean);
    if (!list.length) return null;

    const sections = Array.from(document.querySelectorAll("section[id^='shopify-section-']"));
    for (const sec of sections) {
      const txt = norm(sec.textContent);
      if (list.some((n) => txt.includes(n))) return sec;
    }
    return null;
  }

  function hideWrongSleeveBlocks(currentSleeve) {
    // EN titles
    const LONG_TITLE_EN = "More Long Sleeve Options";
    const SHORT_TITLE_EN = "More Short Sleeve Options";
    const SLEEVELESS_TITLE_EN = "More Sleeveless Options";

    // ES titles (locked)
    const LONG_TITLE_ES = "Más opciones de manga larga";
    const SHORT_TITLE_ES = "Más opciones de manga corta";
    const SLEEVELESS_TITLE_ES = "Más opciones sin mangas";

    if (!currentSleeve) return; // don't hide anything if we can't detect sleeve

    const longSec = findSectionContainingAnyText([LONG_TITLE_EN, LONG_TITLE_ES]);
    const shortSec = findSectionContainingAnyText([SHORT_TITLE_EN, SHORT_TITLE_ES]);
    const sleevelessSec = findSectionContainingAnyText([SLEEVELESS_TITLE_EN, SLEEVELESS_TITLE_ES]);

    // Show only the matching one; hide the other two
    if (longSec) longSec.classList.toggle(HIDE_CLASS, currentSleeve !== "longsleeve");
    if (shortSec) shortSec.classList.toggle(HIDE_CLASS, currentSleeve !== "shortsleeve");
    if (sleevelessSec) sleevelessSec.classList.toggle(HIDE_CLASS, currentSleeve !== "sleeveless");
  }

  function run() {
    // 1) Remove current product from featured collections/product grids
    const blocks = document.querySelectorAll(
      'section[id^="shopify-section-"] .featured-collection, section[id^="shopify-section-"] .product-grid, section[id^="shopify-section-"] .grid.product-grid'
    );
    blocks.forEach((b) => removeCurrentProductCards(b));

    // 2) Hide wrong “More ___ Sleeve Options” blocks
    const sleeve = getCurrentSleeveType();
    hideWrongSleeveBlocks(sleeve);

    // 3) Recalc layout
    setTimeout(recalcSliders, 0);
  }

  // Run after DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setTimeout(run, 0));
  } else {
    setTimeout(run, 0);
  }

  // Re-run on theme/editor swaps + variant changes
  document.addEventListener("shopify:section:load", () => setTimeout(run, 0));
  document.addEventListener("shopify:section:reorder", () => setTimeout(run, 0));
  document.addEventListener("variant:change", () => setTimeout(run, 0));
  document.addEventListener("product:variant-change", () => setTimeout(run, 0));
})();
